import styled from 'styled-components'

import { DropzoneWithUrlUnstyled } from './unstyled'

export const DropzoneWithUrl = styled(DropzoneWithUrlUnstyled)`
  img {
    display: inline-block;
  }
`
